module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MF-47bc247b79ecb76b24cf4e853d6fbc8e.png";